import {debounce} from '../debounce'
import {isOnSmallScreen, isTouching} from '../is'

const $window = $(window)
const $body = $('body')

function initProductRating() {
	$body.on('DOMNodeInserted', '.spr-badge', function (e) {
		const $badge = $(e.target)
		$badge.once('ProductBadge').each(function () {
			$badge.find('.spr-badge-caption').on('click', function () {
				$('#reviews').modal('show')
			})

			// A badge is inserted into a region of DOM that must be invisible until
			// product reviews are loaded
			$badge.closest('.js-product-reviews').removeClass('js-product-reviews')
		})
	})

	$body.on('DOMNodeInserted', '#shopify-product-reviews', function (e) {
		if (e.target.id === 'shopify-product-reviews') {
			const $target = $(e.target)
			$target.once('ProductReviews').each(function () {
				const $reviews = $(this)
				const $header = $reviews.siblings('.reviews-header')

				const $summary = $reviews.find('.spr-summary')
				const $actions = $reviews.find('.spr-summary-actions')

				$summary.appendTo($header.find('.reviews-header__section').first())
				$actions.appendTo($header.find('.reviews-header__section').last())
			})

			// OK, the product reviews have loaded, so display all links to the
			// product reviews modal
			$body.find('.js-product-reviews').removeClass('js-product-reviews')
		}
	})
}

function initProductGallery() {
	$('.product-gallery').once('initProductGallery').each(function () {
		const $gallery = $(this)
		const $containers = $gallery.find('.product-gallery-container')
		const $fallback = $gallery.find('.product-gallery-container[data-option=fallback]')
		const index = $gallery.data('optionIndex')

		$containers.removeClass('js-not-yet')
		$window.on('orderForm:variantSelected', function (e, {variant, isSwatchUpdate}) {
			if (!isSwatchUpdate) {
				// Only scroll if a master option was changed
				return
			}

			const scrollTop = $window.scrollTop()
			const option = variant.options[index]
			let $container = $containers.filter(`[data-option="${option}"]`)
			let $target = $()
			if (variant.featured_image) {
				const id = variant.featured_image.id
				const $img = $container.find(`[data-image-id="${id}"]`)
				if ($img.length) {
					$target = $img
				} else {
					// Sometimes a product variant may not have a featured image.
					// When that happens we cannot scroll anywhere, so let's just go to
					// the first image in the fallback container.
					$target = $container.find('.product-gallery__item')
				}
			}

			if (!$target.length) {
				// Still no scroll target? That's probably because we don't have any
				// featured images in our current option container. Good thing we have
				// the fallback container!
				$container = $fallback
				$target = $fallback.find('.product-gallery__item')
			}

			$container.show()
			$containers.not($container).hide()

			$window.scrollTop(0)
		})
	})
}

function initProductInfo() {
	const $info = $('.product-info')
	const $marker = $info.find('.product-info__marker')
	const $content = $info.find('.product-info__content')

	$info.onMutation(() => {
		$marker.height($content.outerHeight())
	})

	$marker.onVisibilityChange((isVisible) => {
		if (isVisible && isOnSmallScreen()) {
			$info.removeClass('product-info--sticky')
		} else {
			$info.addClass('product-info--sticky')
		}
	})

	$(window).on('slippy:update', function (e, {slippyTop, min, max}) {
		if (!isOnSmallScreen()) {
			const offset = Math.abs(slippyTop - min)
			$content.children().first().css('margin-top', `${offset}px`)
		}
	})
}

function initGalleryImageZooming() {
	const $modal = $('#image-zoom')
	const $modalImg = $modal.find('img')
	const $modalBody = $modal.find('.modal-body')

	// TODO Get this to work on Mobile Safari!
	// If I don't stop scrolling on the body when the image zoom modal is open
	// then a user can scroll to the bottom of the image and they will start
	// scrolling the page behind the modal!
	let scrollAmount = 0
	$modal.on('show.bs.modal', function () {
		scrollAmount = $body.scrollTop()
		$body.css({
			'overflow': 'hidden',
			'pointer-events': 'none'
		}).scrollTop(scrollAmount)
	})
	$modal.on('hide.bs.modal', function () {
		$body.css({
			'overflow': '',
			'pointer-events': ''
		})
	})

	$('.product-gallery__item').once('initGalleryImageZooming').each(function () {
		const $item = $(this)
		const $img = $item.find('.picture img')
		const highResImg = $item.data('highResImg')

		let isZooming = false
		$item.on('click', function (e) {
			if (isTouching()) {
				startZoomingOnMobile()
			} else {
				isZooming = !isZooming
				if (isZooming) {
					$item.addClass('product-gallery__item--zoom')
					setTransformOnDesktop(e)
				} else {
					stopZooming()
				}
			}
		})

		$item.on('mouseout', function () {
			if (isTouching()) {
				return
			}
			stopZooming()
		})

		$item.on('mousemove', function (e) {
			if (isTouching()) {
				return
			}
			if (!isZooming) {
				return
			}
			setTransformOnDesktop(e)
		})

		function setTransformOnDesktop(e) {
			const offset = $item.offset()
			const x = 50 - (e.pageX - offset.left) / $item.width() * 100
			const y = 50 - (e.pageY - offset.top) / $item.height() * 100
			const transformString = `translate(${x}%, ${y}%) scale(2)`
			$img.css('transform', transformString)
		}

		function startZoomingOnMobile() {
			$modal.modal('show')
			$modalImg.attr('src', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=')

			const myImage = new Image()
			myImage.onload = function () {
				$modalImg.attr('src', highResImg)
				$modalBody.get(0).scrollTo($modalBody.width() / 2, 0)
			}
			myImage.src = highResImg
		}

		function stopZooming() {
			isZooming = false
			$item.removeClass('product-gallery__item--zoom')
			$img.css('transform', '')
		}
	})
}

/**
 * I'll make sure that you can NOT scroll anything when the sizeguide modal is
 * open EXCEPT for the modal's body.
 */
function initSizeGuide() {
	const bsl = require('body-scroll-lock')
	const $guide = $('#sizeguide').once('initSizeGuide')
	const bodyEl = $guide.find('.modal-body').get(0)
	$guide.on('show.bs.modal', function (e) {
		bsl.disableBodyScroll(bodyEl)
	})
	$guide.on('hide.bs.modal', function (e) {
		bsl.enableBodyScroll(bodyEl)
	})
}

$.fn.onVisibilityChange = function (action) {
	$(this).each(function () {
		const $el = $(this)
		window.addEventListener('scroll', update, {passive: true})
		window.addEventListener('resize', debounce(update, 150))

		function update() {
			let myMarkerPosition = $el.offset().top
			myMarkerPosition += $el.outerHeight()
			const windowBottom = $window.scrollTop() + $window.height()
			const isVisible = myMarkerPosition <= windowBottom
			action(isVisible)
		}
	})
}

$.fn.onMutation = function (action) {
	$(this).each(function () {
		const config = {attributes: true}
		const observer = new MutationObserver(mutations => {
			for (let mutation of mutations) {
				action()
			}
		})
		observer.observe(this, config)
	})
}

export function initProductPage() {
	initProductRating()
	initProductInfo()
	initProductGallery()
	initGalleryImageZooming()
	initSizeGuide()
}
